import { useCartReferenceStore } from "@components/LoadCart"
import { MutationRemoveItemFromCartArgs } from "@generated"
import { getGraphQLClient } from "@lib/graphql-client"
import { useMutation } from "@tanstack/react-query"
import { setCartQueryData } from "./helpers/set-cart-query-data"

const { sdk } = getGraphQLClient()

export function useRemoveItemFromCart() {
  const { reference } = useCartReferenceStore()
  const { mutateAsync, isLoading, error } = useMutation(
    async ({
      cartItemId,
    }: Omit<MutationRemoveItemFromCartArgs, "reference">) => {
      if (reference) {
        return await sdk.RemoveItemFromCart({
          cartItemId,
          reference,
        })
      }
    },
    {
      onSuccess: (data) => {
        if (data && data.removeItemFromCart) {
          setCartQueryData(reference, data.removeItemFromCart)
        }
      },
    }
  )

  return {
    mutateAsync,
    isLoading,
    error,
  }
}
